module.exports = __webpack_public_path__ + "static/img/frontPage2.85dd2049.jpg";